import { v4 } from 'uuid'

import { ItemDTO, ItemType } from 'src/models/dto/items/ItemDTO'
import { Locale, LocalizedAttribute, LocalizeDefault } from 'src/models/dto/Locale'

export interface SingleSelectCheckboxItemDTO extends ItemDTO {
    itemType: ItemType.SingleSelectCheckbox
    statementI18N: LocalizedAttribute<string>
}

export const defaultSingleSelectCheckboxItemDTO = (): SingleSelectCheckboxItemDTO => {
    const newId = v4()
    return {
        id: newId,
        itemType: ItemType.SingleSelectCheckbox,
        label: '',
        locale: Locale.en_US,
        name: newId,
        optional: false,
        preserveOrder: false,
        ppt: ItemType.SingleSelectCheckbox,
        statementI18N: LocalizeDefault<string>(''),
    }
}
